module.exports = __webpack_public_path__ + "static/axiforma-book-webfont-ac346cc7a733daaaf8373be56c219fe9.woff2";